import axios from "axios";
import { toast } from "react-toastify";
import {
  IS_LOADING,
  UPCOMING_MATCH_LIST_SUCCESS,
  UPCOMING_MATCH_LIST_ERROR,
  ACTIVE_MATCH_LIST_SUCCESS,
  ACTIVE_MATCH_LIST_ERROR,
  POOL_LIST_ERROR,
  POOL_LIST_SUCCESS,
  MATCH_STATUS_CHANGED_ERROR,
  MATCH_STATUS_CHANGED_SUCCESS,
  POOL_ADD_SUCCESS,
  POOL_ADD_ERROR,
  POOL_STATUS_CHANGED_SUCCESS,
  POOL_STATUS_CHANGED_ERROR,
  ACTIVE_MATCH_POOL_LIST_SUCCESS,
  ACTIVE_MATCH_POOL_LIST_ERROR,
  PUBLISH_MATCH_POOL_SUCCESS,
  PUBLISH_MATCH_POOL_ERROR,
  ACTIVE_INC_MATCH_POOL_SUCESS,
  ACTIVE_INC_MATCH_POOL_ERROR,
} from "./Type";
import { baseUrlPostGres } from "../constant";
import { apiHeader } from "./ApiHeader";
import "react-toastify/dist/ReactToastify.css";
import HandleError from "../HandleError";
import { apiVersion } from "src/utils/apiVersion";
toast.configure();

export const GetUpcomingMatchListAction = (page, size) => async (dispatch) => {
  dispatch({ type: IS_LOADING });
  await axios
    .get(`${baseUrlPostGres()}/admin/${apiVersion.v1}/match/list?page=${page}&limit=${size}`, {
      headers: apiHeader(),
    })
    .then((response) => {
      dispatch({
        type: UPCOMING_MATCH_LIST_SUCCESS,
        payload: response,
      });
    })
    .catch((errors) => {
      HandleError(errors.response.data);
      dispatch({
        type: UPCOMING_MATCH_LIST_ERROR,
        payload: errors,
      });
    });
};

export const GetMatchActivityListCricketAction = (page, size) => async (dispatch) => {
  dispatch({ type: IS_LOADING });
  await axios
    .get(`${baseUrlPostGres()}/admin/${apiVersion.v1}/match/cricket_activity_list?page=${page}&limit=${size}`, {
      headers: apiHeader(),
    })
    .then((response) => {
      dispatch({
        type: UPCOMING_MATCH_LIST_SUCCESS,
        payload: response,
      });
    })
    .catch((errors) => {
      HandleError(errors.response.data);
      dispatch({
        type: UPCOMING_MATCH_LIST_ERROR,
        payload: errors,
      });
    });
};

export const GetMatchListByStatus =
  (rtype, vid, sdate, edate, page, size) => async (dispatch) => {
    dispatch({ type: IS_LOADING });
    await axios
      .get(
        `${baseUrlPostGres()}/admin/${apiVersion.v1}/match/listByStatus?rtype=${rtype}&vid=${vid}&sdate=${sdate}&edate=${edate}&page=${page}&limit=${size}`,
        {
          headers: apiHeader(),
        }
      )
      .then((response) => {
        dispatch({
          type: UPCOMING_MATCH_LIST_SUCCESS,
          payload: response,
        });
      })
      .catch((errors) => {
        HandleError(errors.response.data);
        dispatch({
          type: UPCOMING_MATCH_LIST_ERROR,
          payload: errors,
        });
      });
  };

export const GetFootBallMatchListByStatus =
  (rtype, vid, sdate, edate, page, size) => async (dispatch) => {
    dispatch({ type: IS_LOADING });
    await axios
      .get(
        `${baseUrlPostGres()}/admin/${apiVersion.v1}/match/footballlistByStatus?rtype=${rtype}&vid=${vid}&sdate=${sdate}&edate=${edate}&page=${page}&limit=${size}`,
        {
          headers: apiHeader(),
        }
      )
      .then((response) => {
        dispatch({
          type: UPCOMING_MATCH_LIST_SUCCESS,
          payload: response,
        });
      })
      .catch((errors) => {
        HandleError(errors.response.data);
        dispatch({
          type: UPCOMING_MATCH_LIST_ERROR,
          payload: errors,
        });
      });
  };

export const GetPoolListAction =
  (id, type, gtype, page, size) => async (dispatch) => {
    dispatch({ type: IS_LOADING });
    let sendData = {
      contest_id: id,
      type: type,
      gtype: gtype,
    };
    await axios
      .post(
        `${baseUrlPostGres()}/admin/${apiVersion.v1}/poolmaster/list?page=${page}&limit=${size}`,
        sendData,
        {
          headers: apiHeader(),
        }
      )
      .then((response) => {
        dispatch({
          type: POOL_LIST_SUCCESS,
          payload: response,
        });
      })
      .catch((errors) => {
        HandleError(errors.response.data);
        dispatch({
          type: POOL_LIST_ERROR,
          payload: errors,
        });
      });
  };

export const GetActiveMatchListAction = (page, size) => async (dispatch) => {
  dispatch({ type: IS_LOADING });

  await axios
    .get(
      `${baseUrlPostGres()}/admin/${apiVersion.v1}/match/active_list?page=${page}&limit=${size}`,
      {
        headers: apiHeader(),
      }
    )
    .then((response) => {
      dispatch({
        type: ACTIVE_MATCH_LIST_SUCCESS,
        payload: response,
      });
    })
    .catch((errors) => {
      HandleError(errors.response.data);
      dispatch({
        type: ACTIVE_MATCH_LIST_ERROR,
        payload: errors.response.data,
      });
    });
};

export const PublichActiveMatchStatusAction = (body) => async (dispatch) => {
  dispatch({ type: IS_LOADING });
  await axios
    .post(`${baseUrlPostGres()}/admin/${apiVersion.v1}/match/publish`, body, {
      headers: apiHeader(),
    })
    .then((response) => {
      dispatch({
        type: PUBLISH_MATCH_POOL_SUCCESS,
        payload: response.data,
      });
      toast.success(response.data.message, { theme: "colored" });
    })
    .catch((errors) => {
      HandleError(errors.response.data);
      dispatch({
        type: PUBLISH_MATCH_POOL_ERROR,
        payload: errors.response.data,
      });
      toast.error(errors.response.data.message, { theme: "colored" });
    });
};

export const MatchChangeStatusAction = (body) => async (dispatch) => {
  dispatch({ type: IS_LOADING });
  await axios
    .post(`${baseUrlPostGres()}/admin/${apiVersion.v1}/match/active-inactive`, body, {
      headers: apiHeader(),
    })
    .then((response) => {
      dispatch({
        type: MATCH_STATUS_CHANGED_SUCCESS,
        payload: response.data,
      });
      toast.success(response.data.message, { theme: "colored" });
    })
    .catch((errors) => {
      HandleError(errors.response.data);
      dispatch({
        type: MATCH_STATUS_CHANGED_ERROR,
        payload: errors,
      });
      toast.error(errors.error.errorMessage.id.message, { theme: "colored" });
    });
};

export const CronActivityAction = (body) => async (dispatch) => {
  dispatch({ type: IS_LOADING });
  await axios
    .post(`${baseUrlPostGres()}/admin/${apiVersion.v1}/match/active-inactive`, body, {
      headers: apiHeader(),
    })
    .then((response) => {
      dispatch({
        type: MATCH_STATUS_CHANGED_SUCCESS,
        payload: response.data,
      });
      toast.success(response.data.message, { theme: "colored" });
    })
    .catch((errors) => {
      HandleError(errors.response.data);
      dispatch({
        type: MATCH_STATUS_CHANGED_ERROR,
        payload: errors,
      });
      toast.error(errors.error.errorMessage.id.message, { theme: "colored" });
    });
};

export const CancelMatchAction = (body) => async (dispatch) => {
  dispatch({ type: IS_LOADING });
  await axios
    .post(`${baseUrlPostGres()}/admin/${apiVersion.v1}/match/cancel-match`, body, {
      headers: apiHeader(),
    })
    .then((response) => {
      dispatch({
        type: MATCH_STATUS_CHANGED_SUCCESS,
        payload: response.data,
      });
      toast.success(response.data.message, { theme: "colored" });
    })
    .catch((errors) => {
      HandleError(errors.response.data);
      dispatch({
        type: MATCH_STATUS_CHANGED_ERROR,
        payload: errors,
      });
      toast.error(errors.error.errorMessage.id.message, { theme: "colored" });
    });
};

export const ResetMatchChangeStatusAction = () => async (dispatch) => {
  dispatch({ type: MATCH_STATUS_CHANGED_SUCCESS, payload: {} });
};

export const ResetCronActivityAction = () => async (dispatch) => {
  dispatch({ type: MATCH_STATUS_CHANGED_SUCCESS, payload: {} });
};

export const PublishMatchPool = (body) => async (dispatch) => {
  dispatch({ type: IS_LOADING });
  body["isChecked"] = body["isChecked"] == 1 ? 0 : 1;
  await axios
    .post(
      `${baseUrlPostGres()}/admin/${apiVersion.v1}/poolmaster/active_inactive_contest_pool_match`,
      body,
      {
        headers: apiHeader(),
      }
    )
    .then((response) => {
      dispatch({
        type: MATCH_STATUS_CHANGED_SUCCESS,
        payload: response.data,
      });
      toast.success(response.data.message, { theme: "colored" });
    })
    .catch((errors) => {
      HandleError(errors.response.data);
      dispatch({
        type: MATCH_STATUS_CHANGED_ERROR,
        payload: errors,
      });
      toast.error(errors.error.errorMessage.id.message, { theme: "colored" });
    });
};

export const ResetPublishMatchPool = () => async (dispatch) => {
  dispatch({
    type: MATCH_STATUS_CHANGED_SUCCESS,
    payload: {},
  });
};

export const ActiveInactiveMatchPool = (body) => async (dispatch) => {
  dispatch({ type: IS_LOADING });
  await axios
    .post(
      `${baseUrlPostGres()}/admin/${apiVersion.v1}/poolmaster/active_inactive_contest_pool_match`,
      body,
      {
        headers: apiHeader(),
      }
    )
    .then((response) => {
      console.log("response is client register", response);
      dispatch({
        type: ACTIVE_INC_MATCH_POOL_SUCESS,
        payload: response.data,
      });
      toast.success(response.data.message, { theme: "colored" });
    })
    .catch((errors) => {
      HandleError(errors.response.data);
      console.log("error is ", errors);
      dispatch({
        type: ACTIVE_INC_MATCH_POOL_ERROR,
        payload: errors,
      });
      toast.error(errors.error.errorMessage.id.message, { theme: "colored" });
      console.log("error is ", errors);
    });
};

export const AddPoolAction = (data, formValues) => async (dispatch) => {
  dispatch({ type: IS_LOADING });
  let sendData = {
    poolData: data,
    breakPrizeData: formValues,
  };
  await axios
    .post(`${baseUrlPostGres()}/admin/${apiVersion.v1}/poolmaster/create`, sendData, {
      headers: apiHeader(),
    })
    .then((response) => {
      dispatch({
        type: POOL_ADD_SUCCESS,
        payload: response,
      });
      toast.success(response.data.message, { theme: "colored" });
    })
    .catch((errors) => {
      HandleError(errors.response.data);
      dispatch({
        type: POOL_ADD_ERROR,
        payload: errors,
      });
    });
};

export const ResetAddPoolAction = () => async (dispatch) => {
  dispatch({
    type: POOL_ADD_SUCCESS,
    payload: {},
  });
};

export const PoolChangeStatusAction = (body) => async (dispatch) => {
  dispatch({ type: IS_LOADING });
  await axios
    .post(`${baseUrlPostGres()}/admin/${apiVersion.v1}/poolmaster/active_inactive_pool`, body, {
      headers: apiHeader(),
    })
    .then((response) => {
      console.log("response is client register", response);
      dispatch({
        type: POOL_STATUS_CHANGED_SUCCESS,
        payload: response.data,
      });
      toast.success(response.data.message, { theme: "colored" });
    })
    .catch((errors) => {
      HandleError(errors.response.data);
      console.log("error is ", errors);
      dispatch({
        type: POOL_STATUS_CHANGED_ERROR,
        payload: errors,
      });
      toast.error(errors.error.errorMessage.id.message, { theme: "colored" });
      console.log("error is ", errors);
    });
};

export const GetActiveMatchAction = (page, limit, body) => async (dispatch) => {
  dispatch({ type: IS_LOADING });
  await axios
    .post(
      `${baseUrlPostGres()}/admin/${apiVersion.v1}/poolmaster/cricket/active_pool_list?page=${page}&limit=${limit}`,
      body,
      {
        headers: apiHeader(),
      }
    )
    .then((response) => {
      dispatch({
        type: ACTIVE_MATCH_POOL_LIST_SUCCESS,
        payload: response.data,
      });
    })
    .catch((errors) => {
      HandleError(errors.response.data);
      dispatch({
        type: ACTIVE_MATCH_POOL_LIST_ERROR,
        payload: errors,
      });
      toast.error(errors.error.errorMessage.id.message, { theme: "colored" });
    });
};
export const GetActiveContestMatchAction =
  (page, limit, body) => async (dispatch) => {
    dispatch({ type: IS_LOADING });
    await axios
      .post(
        `${baseUrlPostGres()}/admin/${apiVersion.v1}/poolmaster/cricket/active_contest_pool_status_list?page=${page}&limit=${limit}`,
        body,
        {
          headers: apiHeader(),
        }
      )
      .then((response) => {
        dispatch({
          type: ACTIVE_MATCH_POOL_LIST_SUCCESS,
          payload: response.data,
        });
      })
      .catch((errors) => {
        HandleError(errors.response.data);
        dispatch({
          type: ACTIVE_MATCH_POOL_LIST_ERROR,
          payload: errors,
        });
        toast.error(errors.error.errorMessage.id.message, { theme: "colored" });
      });
  };

export const GetActiveAllContestMatchAction =
  (page, limit, body) => async (dispatch) => {
    dispatch({ type: IS_LOADING });
    console.log("body.vid===>>", body.vid);
    await axios
      .post(
        `${baseUrlPostGres()}/admin/${apiVersion.v1}/poolmaster/cricket/active_all_contest_pool_status_list?vid=${
          body.vid
        }&page=${page}&limit=${limit}`,
        body,
        {
          headers: apiHeader(),
        }
      )
      .then((response) => {
        dispatch({
          type: ACTIVE_MATCH_POOL_LIST_SUCCESS,
          payload: response.data,
        });
      })
      .catch((errors) => {
        HandleError(errors.response.data);
        dispatch({
          type: ACTIVE_MATCH_POOL_LIST_ERROR,
          payload: errors,
        });
        toast.error(errors.error.errorMessage.id.message, { theme: "colored" });
      });
  };

  export const GetActiveAllContestMatchFootballAction =
  (page, limit, body) => async (dispatch) => {
    dispatch({ type: IS_LOADING });
    console.log("body.vid===>>", body.vid);
    await axios
      .post(
        `${baseUrlPostGres()}/admin/${apiVersion.v1}/poolmaster/football/active_all_contest_pool_status_list?vid=${
          body.vid
        }&page=${page}&limit=${limit}`,
        body,
        {
          headers: apiHeader(),
        }
      )
      .then((response) => {
        dispatch({
          type: ACTIVE_MATCH_POOL_LIST_SUCCESS,
          payload: response.data,
        });
      })
      .catch((errors) => {
        HandleError(errors.response.data);
        dispatch({
          type: ACTIVE_MATCH_POOL_LIST_ERROR,
          payload: errors,
        });
        toast.error(errors.error.errorMessage.id.message, { theme: "colored" });
      });
  };

  export const getCurrentMatchList = (page, size, data) => (dispatch) => {
    dispatch({ type: IS_LOADING });
    axios
      .post(`${baseUrlPostGres()}/admin/${apiVersion.v1}/match/current_match_list?page=${page}&size=${size}`, data, {
        headers: apiHeader(),
      })
      .then((response) => {
        dispatch({
          type: ACTIVE_MATCH_LIST_SUCCESS,
          payload: response.data,
        });
      })
      .catch((errors) => {
        HandleError(errors?.response?.data);
        console.log("user list error", errors);
      });
  };

// export const GetActiveSeriesListAction = (page, size) => async (dispatch) => {
//     dispatch({ type: IS_LOADING })
//     let senddata = {
//         cid: 125424
//     }
//     await axios
//         .post(`${baseUrlPostGres()}/admin/${apiVersion.v1}/match/series/active_list?page=${page}&limit=${size}`, senddata, {
//             headers: apiHeader()
//         })
//         .then(response => {
//             dispatch({
//                 type: ACTIVE_SERIES_LIST_SUCCESS,
//                 payload: response
//             })
//         })
//         .catch(errors => {
//             dispatch({
//                 type: ACTIVE_SERIES_LIST_ERROR,
//                 payload: errors
//             })
//         })
// }
